import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';

class DoughNut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {},
    };
  }

  doughNutChartFunctionalData() {
    let labels = this.props.labels;
    let data = this.props.data;

    let bgcolor = [
      '#004876',
      '#ec6607',
      '#e20c18',
      '#666',
      '#844f38',
      '#171815',
    ];
    let finalData = [];
    if (this.props.name) {
      labels.map((val, index) => {
        finalData.push({
          value: data[index],
          name: val,
          itemStyle: { color: bgcolor[index] },
        });
      });
    }
    labels.map((val, index) => {
      finalData.push({
        value: data[val],
        name: val,
        itemStyle: { color: bgcolor[index] },
      });
    });

    this.setState({
      options: {
        title: {
          text: this.props.title,
          id: 'cool',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        legend: {
          orient: 'horizontal',
          top: 30,
          data: labels,
        },
        series: [
          {
            name: this.props.title,
            top: 40,
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: '{b}: {c} ({d}%)',
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            data: finalData,
          },
        ],
      },
    });
  }

  componentDidMount() {
    this.doughNutChartFunctionalData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data !== this.props.data &&
      prevProps.labels !== this.props.labels
    ) {
      this.doughNutChartFunctionalData();
    }
  }

  render() {
    return (
      <>
        {Object.keys(this.props.data).length > 0 ? (
          <ReactEcharts
            option={this.state.options}
            style={{
              height: '50vh',
              width: '40vw',
              left: '-20px',
              top: '11px',
            }}
            opts={{ renderer: 'svg' }}
          />
        ) : (
          <>
            <h4 className='noDataTitle'>{this.props.title}</h4>
            <p style={{ textAlign: 'center', marginTop: '150px' }}>
              No Data Available
            </p>
          </>
        )}
      </>
    );
  }
}

export default DoughNut;
